import { Injectable } from '@angular/core';
import { Subject, Observable, of, BehaviorSubject, throwError } from 'rxjs';
import { filter, concatMap, catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class QueueService {
    private queue: BehaviorSubject<(() => Observable<any>) | null> = new BehaviorSubject<(() => Observable<any>) | null>(null);

    constructor() {
        this.queue
            .pipe(
                filter((x: any) => x != null),
                concatMap((fn: () => Observable<any>) => fn())
            )
            .subscribe();
    }

    enqueue(requestFn: () => Observable<any>): Observable<any> {
        const subject = new Subject<any>();
        this.queue.next(() => requestFn().pipe(
            concatMap(result => {
                subject.next(result);
                subject.complete()
                return of(null);
            }),
            catchError(error => {
                subject.error(error); // Emit the error to the subject
                return throwError(() => error); // Rethrow the error to propagate
            })
        ));
        return subject.asObservable();
    }
}